import { ReactElement } from "react";
import { useLocation } from "react-router-dom";

type Props = {
  pathContains: string;
  children: ReactElement;
};

export default function PathContainsRoute({ pathContains, children }: Props) {
  const location = useLocation();

  if (location.pathname.includes(pathContains)) {
    return children;
  }

  return null;
}
